import * as Server from "@/utils/api";
import { acceptHMRUpdate, defineStore } from 'pinia'
import { useAccountStore } from './account';

export const useOrganizationStore = defineStore({
    id: 'organization',
    state: () => {
        return {
            loading: true,
            selectedOrganization: null,
            organizations: [],
            errors: {},
            area: 'professional'
        }
    },
    getters: {
        manageableOrganizations (state) {
            return state.organizations;
        },
        manageableBrands (state) {
            return state.organizations.filter(o => o.type == "brand");
        },
        ambassadorBrand(state) {
            return state.organizations.find(o => o.is_main_ambassador_brand);
        },
        organizationErrors(state) {
            return state.errors;
        },
    },
    actions: {
        selectOrganization(index) {
            if (this.organizations[index]) {
                return this.selectOrganizationById(this.organizations[index].id);
            }
            return false;
        },
        setArea(area) {
            this.area = area;

            if (!this.loading)
                this.setDefaultOrganization();
        },
        setDefaultOrganization() {
            if (this.area === 'ambassador') {
                let mab = this.organizations.find(o =>
                    o.is_main_ambassador_brand &&
                    o.created_by_user_id === useAccountStore().getId);
                if (mab)
                    this.selectOrganizationById(mab.id)
                else
                    this.selectedOrganization = null;
            }
            else if (!this.selectedOrganization || this.selectedOrganization.is_ambassador_brand) {
                let org = this.organizations.find(o => !o.is_ambassador_brand);
                if (org)
                    this.selectOrganizationById(org.id)
                else
                    this.selectedOrganization = null;
            }
        },
        selectOrganizationById(orgId) {
            const org = this.organizations.find(org => org.id === orgId);
            if (org) {
                this.selectedOrganization = org;
                localStorage.setItem('selected_organisation', orgId);
                return true;
            }
            return false;
        },
        getManagableOrganizations() {
            Server.getManageableOrganizations()
                .then((data) => {
                    this.organizations = data.filter(org => org.created_by?.id === useAccountStore().getId);

                    const savedOrgId = localStorage.getItem('selected_organisation');

                    if (!savedOrgId || !this.selectOrganizationById(savedOrgId)) {
                        this.setDefaultOrganization();
                    }

                    this.loading = false;
                }).catch((error) => {
                    console.error(error);
                });
        }
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useOrganizationStore, import.meta.hot))
}